import { Link } from 'react-router-dom';

const chapters = [
  { icon: 'ri-funds-line', label: 'Gestión de Bankroll' },
  { icon: 'ri-brain-line', label: 'Estrategias de Valor' },
  { icon: 'ri-bar-chart-box-line', label: 'Análisis Estadístico' },
  { icon: 'ri-shield-check-line', label: 'Psicología del Apostador' },
  { icon: 'ri-scales-3-line', label: 'Comparación de Cuotas' },
  { icon: 'ri-trophy-line', label: 'Tipsters Profesionales' },
];

export default function HeroGuia() {
  return (
    <section className="relative min-h-[520px] flex items-center overflow-hidden">
      {/* Background */}
      <div className="absolute inset-0">
        <img
          src="https://readdy.ai/api/search-image?query=dark%20abstract%20financial%20data%20visualization%20with%20glowing%20green%20lines%20and%20charts%20on%20deep%20black%20background%2C%20minimalist%20futuristic%20aesthetic%2C%20bokeh%20light%20particles%2C%20professional%20trading%20atmosphere%2C%20no%20people%2C%20ultra%20wide%20cinematic&width=1440&height=520&seq=guia-hero-001&orientation=landscape"
          alt="Guía del Apostador"
          className="w-full h-full object-cover object-top"
        />
        <div className="absolute inset-0 bg-gradient-to-r from-[#080a0f]/95 via-[#080a0f]/80 to-[#080a0f]/60"></div>
        <div className="absolute inset-0 bg-gradient-to-t from-[#080a0f] via-transparent to-transparent"></div>
      </div>

      <div className="relative max-w-[1440px] mx-auto px-6 py-24 w-full">
        <div className="max-w-2xl">
          {/* Badge */}
          <div className="inline-flex items-center gap-2 px-3 py-1.5 rounded-full bg-[#00e87a]/10 border border-[#00e87a]/20 mb-6">
            <div className="w-1.5 h-1.5 rounded-full bg-[#00e87a]"></div>
            <span className="text-[#00e87a] text-xs font-semibold uppercase tracking-widest">Guía Completa</span>
          </div>

          <h1 className="text-4xl md:text-5xl font-bold text-white leading-tight mb-4" style={{ fontFamily: "'Syne', sans-serif" }}>
            Guía del <span className="text-[#00e87a]">Apostador</span> Inteligente
          </h1>
          <p className="text-[#a8b2c1] text-lg leading-relaxed mb-8">
            Todo lo que necesitas saber para apostar con criterio: desde la gestión del bankroll hasta las estrategias de valor esperado. Aprende a pensar como un profesional.
          </p>

          <div className="flex flex-wrap gap-3 mb-10">
            <a href="#bankroll" className="px-5 py-2.5 bg-[#00e87a] text-black text-sm font-bold rounded-md hover:bg-[#00d070] transition-colors whitespace-nowrap cursor-pointer">
              Empezar a leer
            </a>
            <Link to="/comparador" className="px-5 py-2.5 border border-[#2a2d3a] text-[#a8b2c1] text-sm font-medium rounded-md hover:border-[#00e87a]/40 hover:text-white transition-colors whitespace-nowrap cursor-pointer">
              Ver comparador de cuotas
            </Link>
          </div>

          {/* Chapters quick nav */}
          <div className="flex flex-wrap gap-2">
            {chapters.map((c) => (
              <div key={c.label} className="flex items-center gap-1.5 px-3 py-1.5 bg-white/5 border border-[#2a2d3a] rounded-full">
                <div className="w-4 h-4 flex items-center justify-center">
                  <i className={`${c.icon} text-[#00e87a] text-xs`}></i>
                </div>
                <span className="text-[#a8b2c1] text-xs whitespace-nowrap">{c.label}</span>
              </div>
            ))}
          </div>
        </div>
      </div>
    </section>
  );
}
